// extracted by css-extract-rspack-plugin
export default {"root":"rZj4g7","grid":"nsifgP"};